import PropertySearchFilter from '../../property/filters';
import { fitBoundsAsync, newBoundingBoxEvent, validateBoundingBox } from '../bounding-box';
import { newPropertyFilter } from '../request-filters';
import DrawYourSearch from './draw-your-search';
import SearchThisArea from './search-this-area';

class MapQuickLink {
    constructor( mapSearch, options ) {
        this.mapSearch = mapSearch;
        this.options = options;
        this.container = undefined;
        this.btn = undefined;

        const err = validateBoundingBox( this.options.bbox );

        if ( err ) {
            throw new Error( 'invalid bounding box: ' + err.message );
        }
    }

    onAdd( map ) {
        this.map = map;

        this.container = document.createElement( 'div' );
        this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-custom mapboxgl-ctrl-quick-link';

        this.btn = document.createElement( 'button' );
        this.btn.type = 'button';
        this.btn.dataset.text = this.options.text;
        this.btn.dataset.t = this.options.name;

        this.btn.addEventListener( 'click', this._click.bind( this ) );

        const initialSearchFilter = PropertySearchFilter.fromURLSearchParams( new URLSearchParams( window.location.search ) );

        if ( initialSearchFilter.area.length > 0 ) {
            this.btn.classList.add( 'd-none' );
        }

        const bg = document.createElement( 'span' );
        bg.className = 'bg';
        bg.style.backgroundImage = 'url(' + this.options.imageURL.toString() + ')';

        this.btn.appendChild( bg );
        this.container.appendChild( this.btn );

        this.mapSearch.on( 'twc:mapsearch:updated', () => {
            const locationKey = this.mapSearch.locationKey.value;

            if ( locationKey === 'spain' || locationKey.length === 0 ) {
                this.btn.classList.remove( 'd-none' );
                return;
            }

            const valuesToHideFor = [
                SearchThisArea.id,
                DrawYourSearch.id,
                'map-area',
            ];

            if ( valuesToHideFor.includes( locationKey ) ) {
                this.btn.classList.add( 'd-none' );
                return;
            }

            const locationKeyInt = parseInt( locationKey );

            if ( locationKeyInt > 0 ) {
                this.btn.classList.add( 'd-none' );
            }

            const filter = PropertySearchFilter.fromURLSearchParams( new URLSearchParams( window.location.search ) );

            if ( filter.anyLocationFilters() ) {
                this.btn.classList.add( 'd-none' );
            } else {
                this.btn.classList.remove( 'd-none' );
            }
        } );

        return this.container;
    }

    onRemove() {
        this.map = undefined;
        this.btn.remove();
    }

    async _click() {
        this.mapSearch.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:remove-area', {
            bubbles: true,
            detail: {
                search: false,
            },
        } ) );

        this.mapSearch.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:draw-your-search:deactivate', {
            bubbles: true,
            detail: {
                search: false,
            },
        } ) );

        this.mapSearch.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:hide-remove-search-area', { bubbles: true } ) );

        this.mapSearch.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:search-this-area:deactivate', { bubbles: true } ) );

        this.mapSearch.root.dispatchEvent( new CustomEvent( 'twc:collapse:collapse-all', { bubbles: true } ) );

        const bbox = this.options.bbox;
        const bboxOptions = {};
        const bboxEvent = newBoundingBoxEvent();

        if ( this.options.beforeclick ) {
            this.options.beforeclick( this );
        }

        await fitBoundsAsync( this.mapSearch, {
            bbox: bbox,
            options: bboxOptions,
            event: bboxEvent,
        } );

        const bounds = this.map.getBounds();

        const propertyParams = newPropertyFilter( {
            boundSW: bounds.getSouthWest().lat.toString() + ',' + bounds.getSouthWest().lng.toString(),
            boundNE: bounds.getNorthEast().lat.toString() + ',' + bounds.getNorthEast().lng.toString(),
        }, this.mapSearch.baseForm );

        propertyParams.set( 'currentLocationID', this.options.currentLocationID );
        propertyParams.set( 'currentLocationType', this.options.currentLocationType );

        const options = {
            fetchFeatures: false,
            fetchProperties: true,
            propertySearchURL: this.mapSearch.propertySearchURL,
            propertySearchParams: propertyParams,
        };

        const meta = {
            focusMapToSearch: false,
        };

        if ( this.options.featureSearchURL && this.options.featureSearchParams ) {
            options.fetchFeatures = true;
            options.featureSearchURL = this.options.featureSearchURL;
            options.featureSearchParams = this.options.featureSearchParams;
        }

        await this.mapSearch.update( options, meta );

        this.mapSearch.previousSearchState = propertyParams.toString();

        if ( this.options.hideAfterClick ) {
            this.btn.classList.add( 'd-none' );
        }

        this.mapSearch.setLoading( false );
    }
}

export default MapQuickLink;
